

exports.__esModule = true;
exports.$AuthorizationMessageRoute = undefined;

require('./directive');

var _squid = require('squid');

var $AuthorizationMessageRoute = exports.$AuthorizationMessageRoute = _squid.$ComponentRoute.extend('$AuthorizationMessageRoute', {

    path: 'authorizationmessage',
    directive: 'xo-authorization-message',
    titleContent: 'authUserLearnMore.authUserTitle',

    trackingData: {
        fptiState: 'authorizationmessage',
        templateName: 'authorizationMessage.dust',
        pageGoal: 'Authorization Message',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-authorizationmessage',
                'pagename2': '%::fullpage-authorizationmessage:member:hermes:',
                'version': 'member:%:'
            }
        }
    }
});

angular.value("$AuthorizationMessageRoute", $AuthorizationMessageRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-authorization-message/route.js
// module id = ./pages/xo-authorization-message/route.js
// module chunks = 1